import React from 'react';

const TimeframeSelectorSkeleton = () => {

  return (
    <div className="flex space-x-2 md:mr-8">
      <div style={{ width: '109.5px', height: '36' }}
        className="py-2 px-4 text-sm font-medium rounded bg-gray-200 animate-pulse "
      >
      </div>
    </div>
  );
};

export default TimeframeSelectorSkeleton;
